import { Component, AfterViewInit, OnInit, ViewChild } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  AbstractControl,
  ValidatorFn,
} from '@angular/forms';
import { MaincontainerComponent } from '../maincontainer/maincontainer.component';
import { Base } from '../common/base';
import { MatTableDataSource } from '@angular/material/table';
import { OportunidadComercialService } from '../../services/oportunidad-comercial/oportunidad-comercial.service';
import { MY_DATE_FORMATS } from '../../utils/date-format';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { NgxSpinnerService } from 'ngx-spinner';
import { TrackingService } from '../../services/app-track/tracking.service';
import { TrackData } from '../../models/app-track/track-data.model';
import { StorageService } from '../../utils/util.storage.service';
import { UserLoggedResponse } from '../../models/user';
import { DialogOportunidadesComponent } from '../common/dialogs/dialog-oportunidades/dialog-oportunidades.component';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from '../../services/security/auth.service';
import { Router } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';

@Component({
  selector: 'app-oportunidades-comerciales-internos',
  templateUrl: './oportunidades-comerciales-internos.component.html',
  styleUrls: ['./oportunidades-comerciales-internos.component.css'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
})
export class OportunidadesComercialesInternosComponent
  extends Base
  implements AfterViewInit, OnInit
{
  frmOportunidades!: FormGroup; // Con '!' para evitar error de inicialización

  tipo_id = [
    'BG – BEBÉ GESTANTE',
    'CC – CÉDULA DE CIUDADANÍA',
    'CE – CÉDULA DE EXTRANJERÍA',
    'CN - NACIDO VIVO',
    'PA – PASAPORTE',
    'PE – PERMISO ESPECIAL DE PERMANENCIA',
    'PT – PERMISO POR PROTECCIÓN TEMPORAL',
    'TI – TARJETA DE IDENTIDAD',
    'RC – REGISTRO CIVIL DE NACIMIENTO',
  ];

  estados = [
    'REGISTRADA',
    'ACERCAMIENTO Y CITA',
    'DIAGNÓSTICO DE NECESIDADES',
    'PRESENTACIÓN DE LA OFERTA Y SEGUIMIENTO',
    'CERRADA PERDIDA',
    'CERRADA GANADA',
  ];

  estadosCantidad: { [estado: string]: number } = {};

  haveResponde: boolean = false;
  haveDataToShow: boolean = false;
  dsOportunidades: MatTableDataSource<any> = new MatTableDataSource<any>();
  attrData: string[] = [
    'fecha creación oportunidad comercial',
    'tipo de identificación usuario',
    'numero de identificación usuario',
    'nombre y apellido usuario',
    'celular',
    'correo electrónico',
    'estado oportunidad comercial',
    'fecha última gestión',
    'cumplimiento tiempos de gestión',
  ];

  namesColumns: string[] = [
    'Fecha creación oportunidad comercial',
    'Tipo de identificación usuario',
    'Número de identificación usuario',
    'Nombre y apellido usuario',
    'Celular',
    'Correo electrónico',
    'Estado oportunidad comercial',
    'Fecha última gestión',
    'Cumplimiento tiempos de gestión',
  ];
  generalMessage: string = '';

  logInfo: any;
  cedulaAsesor: any;
  nombreAsesor: any;
  trackDataOportunidad!: TrackData;

  reglasSemaforo: any[] = [];
  

  loggedUserData: UserLoggedResponse = new UserLoggedResponse();

  constructor(
    private mainCmp: MaincontainerComponent,
    private fb: FormBuilder,
    private oportunidadService: OportunidadComercialService,
    private spinner: NgxSpinnerService,
    private authService: AuthService,
    private trackingService: TrackingService,
    private storageService: StorageService,
    private matDialog: MatDialog,
    public router: Router
  ) {
    super();
  }

  private paginatorInterno! : MatPaginator;

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  async ngOnInit(): Promise<void>  {
    this.logInfo = await this.authService.getAuthInfo();
    const userCC = this.logInfo?.document;
    this.cedulaAsesor = userCC.split('.')[1].trim();
    this.nombreAsesor = this.logInfo
          ? `${this.logInfo.nombre ?? ''} ${this.logInfo.primerApellido ?? ''} ${
              this.logInfo.segundoApellido ?? ''
            }`.trim()
          : 'N/A';
  

    this.trackDataOportunidad = {
      module: 'Mis oportunidades comerciales',
      category: 'N/A',
      submodule: 'Consulta mis oportunidades comerciales',
      functionality: 'Consultar',
      cedulaAsesor: this.cedulaAsesor,
      fechaInteraccion: this.getCurrentTimestamp(),
      nombreAsesor: this.nombreAsesor,
      identificadorInteraccion: 'OPO_COM_CONSULTA_OPO_COM_CONSULTAR'
    };

    this.frmOportunidades = this.fb.group({
      tipo_identificacion: [''],
      identificacion: [''],
      estado_oportunidad: [''],
      fecha_creacion: [''],
      fecha_ultima_gestion: [''],
    });

    const filtros = {
      identificacion: '',
      estado_oportunidad: '',
    };

    const tipoIdSeleccionado = '';

    const request = {
      accountTipoDocumento: tipoIdSeleccionado,
      accountNumeroIdentificacion: filtros.identificacion || '',
      stageName: filtros.estado_oportunidad || '',
      ownerIdentificacin: this.cedulaAsesor,
    };

    this.oportunidadService.getOportunidadesFiltradas(request).subscribe({
      next: (response) => {
        this.spinner.hide();
        const records = response?.data?.records || [];

        this.oportunidadService.mostrarMensajeModal().subscribe({
          next: (modalResp) => {
            this.spinner.hide();

            const templateHtml = modalResp?.data?.content?.template || '';

            // Extraer estados del HTML recibido
            const estadoRegex = /<div[^>]*>\s*([^–<]+)\s*–\s*XX\s*<\/div>/g;
            let estadosExtraidos: string[] = [];
            let match;
            while ((match = estadoRegex.exec(templateHtml)) !== null) {
              estadosExtraidos.push(match[1].trim().toUpperCase());
            }

            // Inicializar conteo con estados extraidos en 0
            const conteo: Record<string, number> = {};
            estadosExtraidos.forEach((e) => (conteo[e] = 0));

            // Contar oportunidades por estado basado en estados extraidos
            records.forEach((op: any) => {
              const estado = (op.StageName || 'SIN ESTADO').toUpperCase();
              if (conteo.hasOwnProperty(estado)) {
                conteo[estado] += 1;
              }
            });

            this.matDialog
              .open(DialogOportunidadesComponent, {
                width: '500px',
                data: {
                  conteo,
                  template: templateHtml,
                },
              })
              .afterClosed()
              .subscribe(() => {});
          },
          error: () => {
            this.spinner.hide();
            alert('Error al obtener mensaje del modal');
          },
        });
      },
      error: () => {
        this.spinner.hide();
        alert('Error al obtener oportunidades');
      },
    });

    this.consultarReglasDeSemaforizacion();
  }

  private configurarOrdenamiento(): void {
    const columnasPermitidas = [
      'fecha creación oportunidad comercial',
      'numero de identificación usuario',
      'estado oportunidad comercial',
      'fecha última gestión',
    ];

    this.dsOportunidades.sortingDataAccessor = (
      item: any,
      columna: string,
    ): string | number => {
      const columnaNormalizada = columna
        .trim()
        .toLocaleLowerCase('es-CO');

      if (!columnasPermitidas.includes(columnaNormalizada)) {
        return '';
      }

      const valor = item[columna];

      if (valor === null || valor === undefined || valor === '') {
        return '';
      }

      switch (columnaNormalizada) {
        case 'fecha creación oportunidad comercial':
        case 'fecha última gestión':
          return this.convertirFechaParaOrdenar(valor);

        case 'numero de identificación usuario':
          return Number(valor) || 0;

        case 'estado oportunidad comercial':
          return String(valor)
            .trim()
            .toLocaleLowerCase('es-CO');

        default:
          return '';
      }
    };
  }

  private convertirFechaParaOrdenar(valor: unknown): number {
    if (!valor) {
      return 0;
    }

    const texto = String(valor).trim();

    const fechaDDMMYYYY = texto.match(
      /^(\d{1,2})\/(\d{1,2})\/(\d{4})/,
    );

    if (fechaDDMMYYYY) {
      const [, dia, mes, anio] = fechaDDMMYYYY;

      return new Date(
        Number(anio),
        Number(mes) - 1,
        Number(dia),
      ).getTime();
    }

    const fecha = new Date(texto);

    return Number.isNaN(fecha.getTime())
      ? 0
      : fecha.getTime();
  }

  get getControl() {
    return this.frmOportunidades.controls;
  }

  ngAfterViewInit(): void {
    this.dsOportunidades.sort = this.sort;
    this.dsOportunidades.paginator = this.paginator;

    this.configurarOrdenamiento();

    setTimeout(() => {
      this.mainCmp.setTitle('CONSULTA MIS OPORTUNIDADES COMERCIALES');
    });
  }

  consultarReglasDeSemaforizacion(): void {
    this.oportunidadService.consultarReglasDeSemaforizacion().subscribe({
      next: (resp) => {
        this.reglasSemaforo = resp.data.content || [];
      },
      error: (err) => console.error('Error cargando reglas', err),
    });
  }

  normalizarEstado(estado: string): string {
    return estado
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();
  }

  calcularTotalesPorEstado(oportunidades: any[]): { [estado: string]: number } {
    const conteo: { [estado: string]: number } = {};

    oportunidades.forEach((item) => {
      const estado = (item['estado oportunidad comercial'] || '')
        .toLowerCase()
        .trim();

      if (estado) {
        conteo[estado] = (conteo[estado] || 0) + 1;
      }
    });

    return conteo;
  }

  consultar(): void {
    this.spinner.show();
    if (!this.frmOportunidades.valid) {
      this.generalMessage = 'Por favor completa los campos correctamente.';
      this.haveResponde = false;
      this.haveDataToShow = false;
      this.dsOportunidades.data = [];
      this.spinner.hide();
      return;
    }

    const filtros = this.frmOportunidades.value;

    const tipoIdSeleccionado = filtros.tipo_identificacion
      ? filtros.tipo_identificacion.split(' – ')[0]
      : '';

    const userCC: UserLoggedResponse = this.storageService.getItem('user');
    const cedulaAsesor =
      userCC?.document?.split('. ')[1] || userCC?.document || '';

    const request = {
      accountTipoDocumento: tipoIdSeleccionado,
      accountNumeroIdentificacion: filtros.identificacion || '',
      stageName: filtros.estado_oportunidad || '',
      ownerIdentificacin: cedulaAsesor,
    };

    this.oportunidadService.getOportunidadesFiltradas(request).subscribe({
      next: (response) => {
        const records = response?.data?.records || [];

        const oportunidadesRaw = records.map((r: any) => {
          const estado = r.StageName || '';
          let diasDiferencia = 0;

          // Calcular días según el estado
          if (estado.toLowerCase() === 'registrada') {
            const fechaCreacion = r.CreatedDate
              ? new Date(r.CreatedDate.split('T')[0])
              : null;
            diasDiferencia = fechaCreacion
              ? Math.floor(
                  (new Date().getTime() - fechaCreacion.getTime()) /
                    (1000 * 3600 * 24)
                )
              : 0;
          } else if (
            estado.toLowerCase() !== 'cerrada ganada' &&
            estado.toLowerCase() !== 'cerrada perdida'
          ) {
            const fechaUltima = r.CMV_fecha_ultima_modificacion_etapa__c
              ? new Date(r.CMV_fecha_ultima_modificacion_etapa__c.split('T')[0])
              : null;
            diasDiferencia = fechaUltima
              ? Math.floor(
                  (new Date().getTime() - fechaUltima.getTime()) /
                    (1000 * 3600 * 24)
                )
              : 0;
          }

          // Buscar la regla que aplica
          const normalizar = (txt: string) =>
            txt
              .normalize('NFD') // separa acentos
              .replace(/[\u0300-\u036f]/g, '') // quita tildes
              .trim()
              .toLowerCase();

          const estadoNormalizado = normalizar(estado);

          // 🔍 Debug de cada regla que corresponde a este estado
          this.reglasSemaforo
            .filter((r) => normalizar(r.statusName) === estadoNormalizado)
            .forEach((r) => {
              console.log(
                `Evaluando regla -> estado: ${r.statusName}, condicion: ${
                  r.conditionName
                }, rangoMin: ${r.rangeMin}, rangoMax: ${
                  r.rangeMax
                }, dias: ${diasDiferencia}, resultado: ${this.evaluarCondicion(
                  r,
                  diasDiferencia
                )}`
              );
            });

          // Buscar la regla que aplica
          const regla = this.reglasSemaforo.find(
            (regla) =>
              normalizar(regla.statusName) === estadoNormalizado &&
              this.evaluarCondicion(regla, diasDiferencia) &&
              regla.active
          );

          let color = '';
          if (regla) {
            color = regla.colorName.toLowerCase();
          } else if (estado.toLowerCase() === 'cerrada ganada') {
            color = 'verde';
          } else if (estado.toLowerCase() === 'cerrada perdida') {
            color = 'negro';
          }

          return {
            color, // útil para estilos dinámicos en la tabla
            'fecha creación oportunidad comercial':
              r.CreatedDate?.split('T')[0] || '',
            'tipo de identificación usuario':
              r.Account?.CMV_TipoDocumento__c || '',
            'numero de identificación usuario':
              r.Account?.CMV_NumeroIdentificacion__c || '',
            'nombre y apellido usuario': r.Account?.Name || '',
            celular: r.Account?.CMV_Celular__c || '',
            'correo electrónico': (r.Account?.PersonEmail || '').replace(
              /,/g,
              '\n'
            ),
            'estado oportunidad comercial': estado,
            'fecha última gestión':
              r.CMV_fecha_ultima_modificacion_etapa__c?.split('T')[0] || '',
            'cumplimiento tiempos de gestión': color,
          };
        });

        // === FILTRO POR FECHAS ===
        const filtroFechaCreacion = filtros.fecha_creacion
          ? filtros.fecha_creacion.format('YYYY-MM-DD')
          : null;

        const filtroFechaUltima = filtros.fecha_ultima_gestion
          ? filtros.fecha_ultima_gestion.format('YYYY-MM-DD')
          : null;

        let oportunidadesFiltradas = oportunidadesRaw;

        if (filtroFechaCreacion) {
          oportunidadesFiltradas = oportunidadesFiltradas.filter(
            (item: any) =>
              item['fecha creación oportunidad comercial'] ===
              filtroFechaCreacion
          );
        }

        if (filtroFechaUltima) {
          oportunidadesFiltradas = oportunidadesFiltradas.filter(
            (item: any) => item['fecha última gestión'] === filtroFechaUltima
          );
        }

        oportunidadesFiltradas.sort((a: any, b: any) => {
          const fechaA = a['fecha creación oportunidad comercial']
            ? new Date(a['fecha creación oportunidad comercial']).getTime()
            : 0;

          const fechaB = b['fecha creación oportunidad comercial']
            ? new Date(b['fecha creación oportunidad comercial']).getTime()
            : 0;

          return fechaB - fechaA;
        });

        this.dsOportunidades.data = oportunidadesFiltradas;

        this.haveDataToShow = oportunidadesFiltradas.length > 0;
        this.haveResponde = true;

        this.generalMessage = this.haveDataToShow
          ? ''
          : 'No se encontraron oportunidades con los filtros aplicados.';

        setTimeout(() => {
          if (this.paginator) {
            this.dsOportunidades.paginator = this.paginator;
            this.paginator.firstPage();
          }

          if (this.sort) {
            this.dsOportunidades.sort = this.sort;
          }
        });

        this.spinner.hide();
      },
      error: () => {
        this.spinner.hide();
        this.haveResponde = true;
        this.haveDataToShow = false;
        this.generalMessage = 'Ocurrió un error consultando las oportunidades.';
      },
    });
  }

  evaluarCondicion(regla: any, dias: number): boolean {
    const condicion = regla.conditionName.toLowerCase();

    // Si la regla es para "Cerrada ganada" o "Cerrada perdida", siempre aplica
    if (
      regla.statusName.toLowerCase().includes('cerrada ganada') ||
      regla.statusName.toLowerCase().includes('cerrada perdida')
    ) {
      return true;
    }

    // switch (condicion) {
    //   case 'menor o igual que':
    //     if (regla.rangeMax != null) return dias <= regla.rangeMax;
    //     if (regla.rangeMin != null) return dias <= regla.rangeMin;
    //     return false;

    //   case 'mayor o igual que':
    //     if (regla.rangeMin != null) return dias >= regla.rangeMin;
    //     if (regla.rangeMax != null) return dias >= regla.rangeMax;
    //     return false;

    //   case 'igual a':
    //     return regla.rangeMin != null && dias === regla.rangeMin;

    //   case 'entre':
    //     return (
    //       regla.rangeMin != null &&
    //       regla.rangeMax != null &&
    //       dias >= regla.rangeMin &&
    //       dias <= regla.rangeMax
    //     );

    //   default:
    //     return false;
    // }

    switch (condicion) {
      case 'menor o igual que':
        return dias <= (regla.rangeMax ?? regla.rangeMin);
      case 'mayor o igual que':
        return dias >= regla.rangeMin;
      case 'igual a':
        return dias === regla.rangeMin;
      case 'entre':
        return dias >= regla.rangeMin && dias <= regla.rangeMax;
      default:
        return false;
    }
  }

  clear(): void {
    this.frmOportunidades.reset();
    this.generalMessage = '';
    this.haveResponde = false;
    this.haveDataToShow = false;
    this.dsOportunidades.data = [];
  }

  override hasError(control: AbstractControl | null): boolean {
    return !!(control && control.invalid && (control.dirty || control.touched));
  }

  override printError(
    control: AbstractControl | null,
    customMessages?: { [key: string]: string }
  ): string {
    if (!control || !control.errors) return '';

    const errors = control.errors;
    const messages: { [key: string]: string } = {
      required: 'Este campo es obligatorio.',
      maxlength: 'Longitud máxima excedida.',
      noSpaces: 'No se permite espacios.',
      matDatepickerParse: 'Fecha inválida. Usa el formato YYYY/MM/DD.',
      ...customMessages,
    };

    const firstErrorKey = Object.keys(errors)[0];
    return messages[firstErrorKey] || 'Error desconocido.';
  }

  noSpacesValidator(): ValidatorFn {
    return (control: AbstractControl) => {
      const value = control.value || '';
      const hasSpaces = /\s/.test(value);
      return hasSpaces ? { noSpaces: true } : null;
    };
  }

  private getCurrentTimestamp(): string {
  const fecha = new Date();
  const yyyy = fecha.getFullYear();
  const MM = (fecha.getMonth() + 1).toString().padStart(2, '0');
  const dd = fecha.getDate().toString().padStart(2, '0');
  const HH = fecha.getHours().toString().padStart(2, '0');
  const mm = fecha.getMinutes().toString().padStart(2, '0');
  const ss = fecha.getSeconds().toString().padStart(2, '0');
  return `${yyyy}-${MM}-${dd} ${HH}:${mm}:${ss}`;
  }
}
